module.exports = __webpack_public_path__ + "static/media/coated-fabrics-b1.efce2d19.png";